import React from "react";
import { Box, Button, Chip, Stack, TextField, Typography } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import LocalOfferRoundedIcon from "@mui/icons-material/LocalOfferRounded";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    backgroundColor: "rgba(255,255,255,0.03)",
    "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.2)" },
    "&.Mui-focused fieldset": { borderColor: "rgba(0,225,255,0.55)" },
  },
  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.58)" },
  "& .MuiInputBase-input": { color: "#fff" },
};

export default function TagChips({ tags, value, onChange, onAdd, onRemove }) {
  const handleAdd = () => {
    const t = value.trim();
    if (!t) return;
    onAdd?.(t);
    onChange("");
  };

  return (
    <Stack spacing={1.4}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={1.2}>
        <TextField
          fullWidth
          label="Adicionar tag"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Ex: open bar"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAdd();
            }
          }}
          InputLabelProps={{ shrink: true }}
          sx={inputSx}
        />
        <Button
          variant="contained"
          startIcon={<AddRoundedIcon />}
          sx={{
            minHeight: 54,
            px: 2,
            borderRadius: 2,
            fontWeight: 900,
            textTransform: "none",
            background:
              "linear-gradient(135deg, rgba(0,225,255,0.95), rgba(109,255,178,0.95))",
            color: "#042014",
          }}
          onClick={handleAdd}
        >
          Adicionar
        </Button>
      </Stack>

      {tags.length > 0 ? (
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {tags.map((t, idx) => (
            <Chip
              key={`${t}-${idx}`}
              icon={<LocalOfferRoundedIcon sx={{ fontSize: 16 }} />}
              label={t}
              onDelete={() => onRemove?.(idx)}
              sx={{
                py: 2.1,
                borderRadius: 2,
                fontWeight: 800,
                bgcolor: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.08)",
              }}
            />
          ))}
        </Stack>
      ) : (
        <Box
          sx={{
            borderRadius: 2,
            border: "1px dashed rgba(255,255,255,0.12)",
            p: 1.5,
            textAlign: "center",
          }}
        >
          <Typography sx={{ fontSize: 13, color: "rgba(255,255,255,0.46)" }}>
            Nenhuma tag adicionada ainda.
          </Typography>
        </Box>
      )}
    </Stack>
  );
}
